import type { UsageFeeBillSelectFragment } from '~/modules/pricing/graphql/fragments/usageFeeBill.generated';

export enum IUsageFeeBillStatus {
  FAILED = 'FAILED',

  ISSUED = 'ISSUED',

  PAID = 'PAID',

  PAYMENT_FAILED = 'PAYMENT_FAILED',
}

export interface IUsageFeeBill extends UsageFeeBillSelectFragment {
  status: IUsageFeeBillStatus;
}
